import { _ as _sfc_main } from "./VaTreeNode.vue_vue_type_script_lang-95086262.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, withKeys, withModifiers, createElementVNode, renderSlot, normalizeProps, guardReactiveProps, createVNode, createCommentVNode, createTextVNode, toDisplayString, withDirectives, Fragment, renderList, createBlock, createSlots, withCtx, vShow } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaTreeNode_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["role", "aria-expanded", "aria-disabled", "aria-checked", "tabindex"];
const _hoisted_2 = { class: "va-tree-node-root" };
const _hoisted_3 = {
  key: 2,
  class: "va-tree-node-content__item"
};
const _hoisted_4 = ["aria-hidden"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  const _component_va_checkbox = resolveComponent("va-checkbox");
  const _component_va_tree_node = resolveComponent("va-tree-node", true);
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-tree-node", _ctx.treeNodeClassComputed]),
    role: _ctx.roleComputed,
    "aria-expanded": _ctx.isExpandedComputed,
    "aria-disabled": _ctx.$props.node.disabled,
    "aria-checked": !!_ctx.$props.node.checked,
    tabindex: _ctx.tabIndexComputed,
    onKeydown: [
      _cache[4] || (_cache[4] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["up"])),
      _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["right"])),
      _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["down"])),
      _cache[7] || (_cache[7] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["left"])),
      _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["space"])),
      _cache[9] || (_cache[9] = withKeys(withModifiers(($event) => _ctx.handleKeyboardNavigation($event, _ctx.$props.node), ["stop", "prevent"]), ["esc"]))
    ]
  }, [
    createElementVNode("div", _hoisted_2, [
      createElementVNode("div", {
        class: normalizeClass(["va-tree-node-content", _ctx.indentClassComputed]),
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.onNodeClick("node"))
      }, [
        _ctx.$props.node.hasChildren ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "va-tree-node-content__item va-tree-node-content__item--leaf",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.onNodeClick("leaf"), ["stop"]))
        }, [
          renderSlot(_ctx.$slots, "icon-toggle", normalizeProps(guardReactiveProps(_ctx.$props.node)), () => [
            createVNode(_component_va_icon, {
              name: _ctx.isExpandedComputed ? "keyboard_arrow_down" : "keyboard_arrow_right",
              size: "20px"
            }, null, 8, ["name"])
          ])
        ])) : createCommentVNode("", true),
        _ctx.selectable ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "va-tree-node-content__item",
          onClick: _cache[2] || (_cache[2] = withModifiers(() => {
          }, ["stop"]))
        }, [
          renderSlot(_ctx.$slots, "checkbox", normalizeProps(guardReactiveProps(_ctx.$props.node)), () => [
            createVNode(_component_va_checkbox, {
              "model-value": _ctx.$props.node.checked,
              color: _ctx.colorComputed,
              indeterminate: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.toggleCheckbox(_ctx.$props.node, v)),
              class: "va-tree-node__checkbox"
            }, null, 8, ["model-value", "color"])
          ])
        ])) : createCommentVNode("", true),
        _ctx.iconComputed ? (openBlock(), createElementBlock("div", _hoisted_3, [
          renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps(_ctx.$props.node)), () => [
            createVNode(_component_va_icon, {
              name: _ctx.iconComputed,
              size: "small"
            }, null, 8, ["name"])
          ])
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(["va-tree-node-content__body", _ctx.cursorClassComputed])
        }, [
          renderSlot(_ctx.$slots, "content", normalizeProps(guardReactiveProps(_ctx.$props.node)), () => [
            createTextVNode(toDisplayString(_ctx.labelComputed), 1)
          ])
        ], 2)
      ], 2)
    ]),
    withDirectives(createElementVNode("div", {
      "aria-hidden": !_ctx.$props.node.expanded,
      class: normalizeClass(["va-tree-node-children", _ctx.expandedClassComputed])
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.$props.node.children, (childNode) => {
        return openBlock(), createBlock(_component_va_tree_node, {
          key: _ctx.getTrackBy(childNode),
          node: childNode
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (_, name) => {
            return {
              name,
              fn: withCtx((slotScope) => [
                renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotScope)))
              ])
            };
          })
        ]), 1032, ["node"]);
      }), 128))
    ], 10, _hoisted_4), [
      [vShow, _ctx.$props.node.hasChildren]
    ])
  ], 42, _hoisted_1);
}
const _VaTreeNode = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaTreeNode as _
};
//# sourceMappingURL=VaTreeNode-96505897.mjs.map
